import ActivatingAutomationModal from '../modal/activating_automation';
import AutomationSettingsComponent from '../settings';
import CardWrapper from '../../wrapper/card';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { settingNodes } from '../../../redux/slices/workflow';
import { styled } from '@mui/material/styles';
import { UpdateAutomationParams } from '../../../params/redux/automation';
import { updateAutomationThunk } from '../../../redux/thunks/automation';
import { useParams } from 'react-router';
import { useState } from 'react';
import WorkflowBuilder from '../../../pages/automation';
import { a11yProps, CustomTabPanel } from '../../../pages/deals';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Switch, Tab, Tabs, Typography } from '@mui/material';
import { green, red } from '../../../theme/themePrimitives';
import { settingSelectedAutomation, settingShowBuidlerFlag } from '../../../redux/slices/automation';
import { useDispatch, useSelector } from 'react-redux';

const IOSSwitch = styled(Switch)(({ theme }) => ({
    'width': 42,
    'height': 26,
    'padding': 0,
    '& .MuiSwitch-switchBase': {
        'padding': 0,
        'margin': 2,
        'transitionDuration': '300ms',
        '&.Mui-checked': {
            'transform': 'translateX(16px)',
            'color': '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: green[300],
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

const AutomationBuilderComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { selectedAutomation } = useSelector((state: RootState) => state.automation);
    const [value, setValue] = useState<0 | 1>(1);
    const [showModal, setShowModal] = useState<boolean>(false);

    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
        setValue(newValue);
    };

    const navigationBackHandler = () => {
        dispatch(settingSelectedAutomation(null));
        dispatch(settingNodes([]));
        dispatch(settingShowBuidlerFlag(false));
    };

    const onStatusChangeHandler = async () => {
        try {
            const data: UpdateAutomationParams = {
                automation_id: selectedAutomation?.id || 0,
                automation_name: selectedAutomation?.automation_name || '',
                email_thread: selectedAutomation?.email_thread || 0,
                email_subject: selectedAutomation?.email_subject || '',
                pipeline_id: selectedAutomation?.pipeline_id || 0,
                stage_id: selectedAutomation?.stage_id || 0,
                form_id: selectedAutomation?.form_id || 0,
                status: selectedAutomation?.status === 'active' ? 'inactive' : 'active'
            };
            await dispatch(updateAutomationThunk({ data, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            //
        }
    };

    return (
        <Box p={2} display="flex" flexDirection="column" gap={2}>
            <CardWrapper>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Button startIcon={<KeyboardArrowLeft />} variant="text" color="secondary" onClick={navigationBackHandler}>Back to workflow</Button>
                    <Box>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="automation builder tabs"
                        >
                            <Tab
                                label="Builder"
                                {...a11yProps(0)}
                            />
                            <Tab
                                label="Settings"
                                {...a11yProps(1)}
                            />
                        </Tabs>
                    </Box>
                    <Box display="flex" gap={1} alignItems="center">
                        <Box
                            px={2}
                            borderRadius={1}
                            width="max-content"
                            py="0.1rem"
                            bgcolor={selectedAutomation?.status === 'active' ? green[100] : red[50]}
                            color={selectedAutomation?.status === 'active' ? green[400] : red[300]}
                            height="max-content"
                        >
                            <Typography variant="body1" fontWeight="500">{selectedAutomation?.status === 'active' ? 'Active' : 'Not Active'}</Typography>
                        </Box>
                        <IOSSwitch
                            checked={selectedAutomation?.status === 'active'}
                            onChange={onStatusChangeHandler}
                            disabled={Boolean(!(selectedAutomation?.pipeline_id || selectedAutomation?.stage_id || selectedAutomation?.form_id))}
                        />
                    </Box>
                </Box>
            </CardWrapper>
            <CardWrapper>
                <CustomTabPanel value={value} index={0}>
                    <WorkflowBuilder />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <AutomationSettingsComponent />
                </CustomTabPanel>
            </CardWrapper>
            <ActivatingAutomationModal open={showModal} onClose={() => setShowModal(false)} />
        </Box>
    );
};

export default AutomationBuilderComponent;